import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../../axios.js";
import {
  GET_BULK_UPLOAD_TEMPLATE,
  GET_BULK_UPLOAD_LIST,
  DOWNLOAD_BULK_UPLOAD_FILE,
} from "../../../../Urls.js";

const initialState = {
  enrollmentQueuebyDate: { data: [], loading: false, successMessage: "" },
  transactionByDeposit: { data: [], loading: false, successMessage: "" },
};

export const saveEnrollmentQueue = createAsyncThunk(
  "app/bulksmxsfupdateSlice/saveEnrollmentQueue",
  async (payload) => {
    const response = await axios.post("api/v1/Session/save-session-data", {
      enrolment: payload,
    });
    return response.data;
  },
);
export const submitEnrollmentQueue = createAsyncThunk(
  "app/bulksmxsfupdateSlice/submitEnrollmentQueue",
  async (payload) => {
    const response = await axios.post(
      "api/v1/Session/save-and-submit-session-data",
      { enrolment: payload },
    );
    return response.data;
  },
);

export const getbulksmxsfupdateList = createAsyncThunk(
  "app/bulksmxsfupdateSlice/getbulksmxsfupdateList",
  async () => {
    const url = `${GET_BULK_UPLOAD_LIST}`;
    const response = await axios.get(url);
    return response;
  },
);
export const getbulkUploadTemplate = createAsyncThunk(
  "app/bulksmxsfupdateSlice/getbulkUploadTemplate",
  async () => {
    const url = `${GET_BULK_UPLOAD_TEMPLATE}`;
    const response = await axios.get(url);
    return response;
  },
);
export const downloadBulkUploadSample = createAsyncThunk(
  "app/get/payement/downloadBillingHistory",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.get(DOWNLOAD_BULK_UPLOAD_FILE, {
        params: payload,
      });

      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  },
);

export const bulksmxsfupdateSlice = createSlice({
  name: "bulksmxsfupdateSlice",
  initialState,
  reducers: {
    clearData: (state) => {
      state.transactionByDeposit.data = [];
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(getbulksmxsfupdateList.pending, (state) => {
        state.transactionByDeposit.loading = true;
      })
      .addCase(getbulksmxsfupdateList.fulfilled, (state, action) => {
        state.transactionByDeposit.loading = false;
        state.transactionByDeposit.data = action?.payload?.data;
      })
      .addCase(getbulksmxsfupdateList.rejected, (state) => {
        state.transactionByDeposit.loading = false;
        state.transactionByDeposit.data = [];
      });
  },
});
export const { clearData } = bulksmxsfupdateSlice.actions;

export default bulksmxsfupdateSlice.reducer;
